export const SMS_SYSTEM_CREATE_EDIT_OPEN_MODAL = "SMS_SYSTEM_CREATE_EDIT_OPEN_MODAL";
export const SMS_SYSTEM_CREATE_REQUEST = "SMS_SYSTEM_CREATE_REQUEST";
export const SMS_SYSTEM_CREATE_RESULT = "SMS_SYSTEM_CREATE_RESULT";
export const SMS_SYSTEM_EDIT_REQUEST = "SMS_SYSTEM_EDIT_REQUEST";
export const SMS_SYSTEM_EDIT_RESULT = "SMS_SYSTEM_EDIT_RESULT";
export const SMS_SYSTEM_GET_REQUEST = "SMS_SYSTEM_GET_REQUEST";
export const SMS_SYSTEM_GET_RESULT = "SMS_SYSTEM_GET_RESULT";